import { Component, OnInit, AfterViewInit } from '@angular/core';

// declare $ for Jquery Initialization
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit {

  constructor() { }
  ngAfterViewInit () {
    // Slider Jquery Initialization
  $(document).ready(function() {
    $('.slider').slider({
      indicators: false
    });
  });
}

  ngOnInit() {
  }

}
